import {Component, OnInit} from "@angular/core";
import {UserService} from "../users/services/users.service";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../../services/auth.service";
import {AuthenticateDto} from "../../models/authenticate-dto";
import {Auth2Service} from "../../services/auth2.service";
import {HttpErrorResponse} from "@angular/common/http";
import {ApiService} from "../../services/api.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})
export class LoginComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'https://www.scalanthropy.com/'},
    { label: 'Home', path: 'https://www.scalanthropy.com/'},
    { label: 'Login'}
  ];

  username: string = '';
  password: string = '';

  showMessages: boolean = false;
  messages: any[] = [];

  constructor(private apiService: ApiService,
              private userService: UserService,
              private router: Router,
              private authService: AuthService, private auth2Service: Auth2Service,
              private route: ActivatedRoute,
              private titleService: Title) {
    titleService.setTitle("Scalanthropy Login")
  }

  ngOnInit(): void {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    /*
    let idToken: string = this.auth2Service.getIdToken();
    let expTime: number = parseInt(this.auth2Service.getExp());
    let isConsultant: string = this.auth2Service.getIsConsultant();
    if (idToken && expTime) {
      if (isConsultant == 'Y') {
        this.router.navigateByUrl('app/consultants/users/account/selection');
        return;
      } else {
        this.router.navigateByUrl('app/users/dashboard');
        return;
      }
    }*/
  }

  showMessagesToUser(): void {
    this.showMessages = true;
    const counterFn = () => {
      this.showMessages = false;
    }
    setTimeout(counterFn, 8000);
  }

  onSignIn(): any {
    localStorage.removeItem('impersonatedEmail');
    localStorage.removeItem('consultantRoleName');
    this.messages = [];
    const usernameEl = document.getElementById('username-text-id');
    // @ts-ignore
    const username = usernameEl.value;
    if (!username) {
      this.messages.push({
        field: 'Username',
        detail: 'Username: ' + username + ' is not valid.',
        severity: 'error'
      })
    }
    const passwordEl = document.getElementById('password-text-id');
    // @ts-ignore
    const password = passwordEl.value;
    if (!password) {
      this.messages.push({
        field: 'Password',
        detail: 'Password: ' + password + ' is not valid.',
        severity: 'error'
      });
    }
    if (this.messages.length > 0) {
      this.showMessagesToUser();
      return;
    }

    const authenticateDto: AuthenticateDto = {
      'userId': '',
      'username': this.apiService.trimLeadingTrailingSpaces(username.toLowerCase()),
      'password': password,
      'loggedIn': false,
      'lastSessionId': '',
      'sessionStartDate': '',
      'sessionExpirationDate': '',
      'message': ''
    }

    this.auth2Service.authenticateV2(authenticateDto).subscribe((result: any) => {
      if (result && result.body) {
        this.auth2Service.cacheSessionFull(result.body)
        if (result.body.isConsultant == 'Y') {
          this.router.navigateByUrl('app/consultants/users/account/selection');
        } else {
          this.router.navigateByUrl('app/users/dashboard');
        }
      }
    }, (err: HttpErrorResponse) => {
      if (err.error && err.error.locked == true) {
        this.messages.push({
          field: 'Account Locked',
          //detail: 'Account is locked. Too many invalid logins.',
          detail: err.error.message,
          severity: 'error'
        });
      } else if (err.error && err.error.locked == false) {
        this.messages.push({
          field: 'Login Failure',
          //detail: 'Invalid username or password.',
          detail: err.error.message,
          severity: 'error'
        });
      } else {
        this.messages.push({
          field: 'Login Failure',
          detail: 'Unknown technical error.',
          severity: 'error'
        });
      }
      this.showMessagesToUser();
    })
  }

  onSignUp(): any {
    window.location.href = 'https://www.scalanthropy.com/pricing';
    //this.router.navigateByUrl('/app/users/register');
  }

  onForgotUsername(): any {
    this.router.navigateByUrl('/app/login/forgot-username')
  }

  onForgotPassword(): any {
    this.router.navigateByUrl('/app/login/reset-password-request')
  }
  onGetApprovedForConsultants(): any {
    this.router.navigateByUrl('/app/consultants/register/approval')
  }
  onSignUpForApprovedConsultants(): any {
    this.router.navigateByUrl('/app/consultants/users/register')
  }
}
